import api from "@/lib/api";

let scriptLoaded = false;
function loadCheckout() {
  return new Promise((resolve) => {
    if (scriptLoaded || window.Razorpay) { scriptLoaded = true; return resolve(true); }
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => { scriptLoaded = true; resolve(true); };
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Opens Razorpay Checkout for a given purpose, then verifies on the backend.
// Pass orderPath + orderBody to use a custom order-creation endpoint (e.g. consultations).
export async function payWithRazorpay({ purpose, estimate_id, plan_id, description, prefill = {}, orderPath, orderBody, onSuccess, onFailure }) {
  const ok = await loadCheckout();
  if (!ok) { onFailure && onFailure(new Error("Could not load the payment window. Check your connection.")); return; }
  let order;
  try {
    const path = orderPath || "/razorpay/create-order";
    const body = orderBody || { purpose, estimate_id, plan_id };
    const { data } = await api.post(path, body);
    order = data;
  } catch (e) { onFailure && onFailure(e); return; }
  const rzp = new window.Razorpay({
    key: order.key_id, amount: order.amount, currency: order.currency, order_id: order.order_id,
    name: "Nirmantra.ai", description: description || "Payment", theme: { color: "#0E9AC8" }, prefill,
    handler: async (resp) => {
      try {
        const { data } = await api.post("/razorpay/verify", {
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
        });
        onSuccess && onSuccess(data);
      } catch (e) { onFailure && onFailure(e); }
    },
    modal: { ondismiss: () => onFailure && onFailure(new Error("cancelled")) },
  });
  rzp.open();
}
